import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { FaShip, FaIndustry, FaUserShield, FaServer } from "react-icons/fa";
import "./About.css";

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section className="about" ref={ref}>
      <motion.div
        className="about-content"
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.div
          className="about-header"
          initial={{ y: 50 }}
          animate={isInView ? { y: 0 } : { y: 50 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>Who We Are</h2>
        </motion.div>

        <div className="about-grid">
          <motion.div
            className="about-text"
            initial={{ x: -50 }}
            animate={isInView ? { x: 0 } : { x: -50 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <p>
              MusterTaker is a cutting-edge digital safety system specifically
              designed for ships and offshore facilities in the Oil & Gas
              industry. Built to support drillships, lifeboats, and other vital
              operations, MusterTaker ensures rapid, accurate logging of all
              personnel during critical situations like emergencies and drills.
            </p>
            <p>
              This real-time system continuously tracks personnel and provides
              live updates to the Bridge, with an option to relay essential
              information to shore, enhancing response times and overall safety.
            </p>
            <p>
              With an architecture built for high redundancy, MusterTaker
              leverages years of experience in Oil & Gas Maritime operations,
              delivering unmatched reliability in the field. It's a powerful
              solution for maintaining safety and accountability where it
              matters most.
            </p>
          </motion.div>

          <motion.div
            className="about-features"
            initial={{ x: 50 }}
            animate={isInView ? { x: 0 } : { x: 50 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="feature">
              <FaShip className="feature-icon" />
              <h3>Maritime Expertise</h3>
              <p>Specialized for maritime and offshore operations</p>
            </div>
            <div className="feature">
              <FaIndustry className="feature-icon" />
              <h3>Industry Focus</h3>
              <p>Tailored for Oil & Gas sector requirements</p>
            </div>
            <div className="feature">
              <FaUserShield className="feature-icon" />
              <h3>Safety First</h3>
              <p>Real-time personnel tracking and accountability</p>
            </div>
            <div className="feature">
              <FaServer className="feature-icon" />
              <h3>High Redundancy</h3>
              <p>Built for reliability in critical situations</p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default About;
